export default {
    cell: {
        padding: 10
    } as React.CSSProperties,
    statusLozenge: {
        display: 'inline-block',
        marginLeft: 7,
        fontWeight: 700,
        backgroundColor: 'rgb(235, 48, 79)',
        color: 'white',
        borderRadius: 12,
        height: 20,
        marginTop: -6,
        marginBottom: 8,
        fontSize: 14,
        paddingTop: 2,
        paddingLeft: 8,
        paddingRight: 8
    }
}